// extracted by mini-css-extract-plugin
export default {"collectButton":"CustomEyeButton_collectButton__uGmY8","eyeWrapper":"CustomEyeButton_eyeWrapper__vuXjx"};